import Vue from "vue";
import VueRouter from "vue-router";
// import { getStore } from "@/utils/localStorage";
// import { Message } from "element-ui";
import SideBanner from "@/views/layout/sideBanner"; //侧边栏组件

Vue.use(VueRouter);


/**
 * hidden: true                   如果设置为true，则项目将不会显示在侧边栏中（默认为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 */

// 没有权限要求的基页
export const constantRoutes = [
  {
    path: "/Login",
    name: "Login",
    hidden: true,
    meta: {
      title: "登陆"
    },
    component: resolve => require(["@/views/login/index.vue"], resolve)
  },
  // 实践考核入口
  {
    path: "/practicalAssessment",
    name: "practicalAssessment",
    hidden: true,
    component: resolve => require(["@/views/practicalAssessment/practicalAssessment.vue"], resolve),
    meta: {
      title: "实践考核"
    }
  },
  // 实践考核入口
  {
    path: "/duplicate",
    name: "duplicate",
    hidden: true,
    component: resolve => require(["@/views/practicalAssessment/duplicate.vue"], resolve),
    meta: {
      title: "实践考核-去查重"
    }
  },
  {
    path: "/degreeApplication",
    name: "degreeApplication",
    hidden: true,
    component: resolve => require(["@/views/academicDegree/degreeApplication.vue"], resolve),
    meta: {
      title: "学位申报"
    }
  },
  {
    path: "/academicDegreeRecord",
    name: "academicDegreeRecord",
    hidden: true,
    component: resolve => require(["@/views/academicDegree/academicDegreeRecord.vue"], resolve),
    meta: {
      title: "学位申报-申请记录"
    }
  },
  {
    path: "/graduationProve",
    name: "graduationProve",
    hidden: true,
    component: resolve => require(["@/views/graduationProve/graduationProve.vue"], resolve),
    meta: {
      title: "毕业证明书"
    }
  },
  {
    path: "/graduationProveTable",
    name: "graduationProveTable",
    hidden: true,
    component: resolve => require(["@/views/graduationProve/graduationProveTable.vue"], resolve),
    meta: {
      title: "毕业证明书-申请记录"
    }
  },
  {
    path: "/uploadImg",
    name: "uploadImg",
    hidden: true,
    meta: {
      title: "上传图片"
    },
    component: resolve => require(["@/views/uploadImg/upload.vue"], resolve)
  },
  {
    path: "/esignH5",
    name: "esignH5",
    hidden: true,
    meta: {
      title: "手写签名"
    },
    component: resolve => require(["@/views/esignH5/esignH5.vue"], resolve)
  },
  {
    path: "/confirmInfo",
    name: "confirmInfo",
    hidden: true,
    component: resolve => require(["@/views/login/confirmInfo.vue"], resolve),
    meta: {
      title: "确认信息"
    }
  },
  {
    path: "/uploadAdmissionPhotos",
    name: "uploadAdmissionPhotos",
    hidden: true,
    component: resolve => require(["@/views/login/uploadAdmissionPhotos.vue"], resolve),
    meta: {
      title: "入学照"
    }
  },
  {
    path: "/upDataID",
    name: "upDataID",
    hidden: true,
    meta: {
      title: "上传身份证"
    },
    component: resolve => require(["@/views/business/upDataID/upDataID.vue"], resolve)
  },
  {
    path: "/verify",
    name: "verify",
    hidden: true,
    component: resolve => require(["@/views/login/verify.vue"], resolve),
    meta: {
      title: "验证"
    }
  },
  {
    path: "/notice",
    name: "notice",
    hidden: true,
    meta: {
      title: "告知书"
    },
    component: resolve => require(["@/views/login/notice.vue"], resolve)
  },
  {
    path: "/appDownload",
    name: "appDownload",
    hidden: true,
    meta: {
      title: "android下载页面"
    },
    component: resolve => require(["@/views/app/download.vue"], resolve)
  },
  {
    path: "/appHome",
    name: "appHome",
    hidden: true,
    component: resolve => require(["@/views/app/index.vue"], resolve),
    meta: {
      title: "app审核官网"
    }
  },
  {
    path: "/forgetPwd",
    name: "forgetPwd",
    hidden: true,
    meta: {
      title: "找回密码"
    },
    component: resolve => require(["@/views/login/forgetPwd.vue"], resolve)
  },
  {
    path: "/verifyCode",
    name: "verifyCode",
    hidden: true,
    meta: {
      title: "找回密码-获取验证码"
    },
    component: resolve => require(["@/views/login/verifyCode.vue"], resolve)
  },
  {
    path: "/changePwd",
    name: "changePwd",
    hidden: true,
    meta: {
      title: "设置新密码"
    },
    component: resolve => require(["@/views/login/changePwd.vue"], resolve)
  },
  {
    path: "/studyNotes",
    name: "studyNotes",
    hidden: true,
    meta: {
      title: "我的课程-课程视频学习"
    },
    component: resolve => require(["@/views/business/course/courseVideo.vue"], resolve)
  },
  {
    path: "/subSuccessfully",
    name: "subSuccessfully",
    hidden: true,
    meta: {
      title: "我的考试-提交成功"
    },
    component: resolve => require(["@/views/business/onlineTest/subSuccessfully.vue"], resolve)
  },
  {
    path: "/onlineTest",
    name: "onlineTest",
    hidden: true,
    component: resolve => require(["@/views/business/onlineTest/onlineTest.vue"], resolve),
    meta: {
      title: "考试中心-考试中"
    }
  },
  {
    path: "/upDataIDQr",
    name: "upDataIDQr",
    hidden: true,
    meta: {
      title: "上传身份证二维码"
    },
    component: resolve => require(["@/views/business/upDataID/upDataIDQr.vue"], resolve)
  },
  {
    path: "/onlineExamOwn",
    name: "onlineExamOwn",
    hidden: true,
    component: resolve => require(["@/views/business/examCenterOwn/onlineExamOwn/onlineExamOwn.vue"], resolve),
    meta: {
      title: "考试中心-考试"
    }
  },
  {
    path: "/onlineExamSuccessOwn",
    name: "onlineExamSuccessOwn",
    hidden: true,
    meta: {
      title: "考试中心-考试-提交成功"
    },
    component: resolve => require(["@/views/business/examCenterOwn/onlineExamOwn/onlineExamSuccessOwn.vue"],
      resolve)
  },
  // 公共页面
  {
    path: "",
    name: "Template",
    hidden: true,
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "公共页面",
      icon: 'iconfont iconyemian-copy-copy-copy',
    },
    children: [
      {
        path: "/subject",
        name: "subject",
        hidden: true,
        component: resolve => require(["@/views/business/course/subject.vue"], resolve),
        meta: {
          title: "课程计划-学习"
        }
      },
      {
        path: "/startPractice",
        name: "startPractice",
        component: resolve => require(["@/views/business/practice/startPractice.vue"], resolve),
        meta: {
          title: "章节练习-练习题"
        }
      },
      {
        path: "/smartPractice",
        name: "smartPractice",
        component: resolve => require(["@/views/business/practice/smartPractice.vue"], resolve),
        meta: {
          title: "智能练习-练习题"
        }
      },
      // {
      //   path: "/allTest",
      //   name: "allTest",
      //   hidden: true,
      //   component: resolve => require(["@/views/business/realTest/index.vue"], resolve),
      //   meta: {
      //     title: "练习中心-所有试卷"
      //   }
      // },
      {
        path: "/homeWork",
        name: "homeWork",
        component: resolve => require(["@/views/business/practice/homeWork.vue"], resolve),
        meta: {
          title: "章节练习-作业题"
        }
      },
      {
        path: "/practiceAnalysis",
        name: "practiceAnalysis",
        hidden: true,
        component: resolve => require(["@/views/business/practice/practiceAnalysis.vue"], resolve),
        meta: {
          title: "章节练习-查看解析"
        }
      },
      // 学习记录
      {
        path: "/myCollectDetail",
        name: "myCollectDetail",
        hidden: true,
        component: resolve => require(["@/views/business/record/calssModule/collectDetail.vue"], resolve),
        meta: {
          title: "学习记录-我的收藏详情"
        }
      },
      {
        path: "/myNotesDetail",
        name: "myNotesDetail",
        component: resolve => require(["@/views/business/record/calssModule/noteDetail.vue"], resolve),
        meta: {
          title: "学习记录-我的笔记详情"
        }
      },
      // 考试中心
      {
        path: "/examDetailsOwn",
        name: "examDetailsOwn",
        hidden: true,
        component: resolve => require([
          "@/views/business/examCenterOwn/participateTestOwn/examDetailsOwn.vue"
        ], resolve),
        meta: {
          title: "考试中心-参与考试"
        }
      },

      // 练习
      {
        path: "/startPractice",
        name: "startPractice",
        hidden: true,
        component: resolve => require(["@/views/business/practice/startPractice.vue"], resolve),
        meta: {
          title: "章节练习-练习题"
        }
      },
      {
        path: "/smartPractice",
        name: "smartPractice",
        hidden: true,
        component: resolve => require(["@/views/business/practice/smartPractice.vue"], resolve),
        meta: {
          title: "智能练习-练习题"
        }
      },
      {
        path: "/homeWork",
        name: "homeWork",
        hidden: true,
        component: resolve => require(["@/views/business/practice/homeWork.vue"], resolve),
        meta: {
          title: "章节练习-作业题"
        }
      },
      {
        path: "/practiceAnalysis",
        name: "practiceAnalysis",
        hidden: true,
        component: resolve => require(["@/views/business/practice/practiceAnalysis.vue"], resolve),
        meta: {
          title: "章节练习-查看解析"
        }
      },
      {
        path: "/testAnalysis",
        name: "testAnalysis",
        hidden: true,
        component: resolve => require(["@/views/business/realTest/testAnalysis.vue"], resolve),
        meta: {
          title: "练习中心-查看解析"
        }
      },
      {
        path: "/realTestStart",
        name: "realTestStart",
        hidden: true,
        component: resolve => require(["@/views/business/realTest/realTestStart.vue"], resolve),
        meta: {
          title: "练习中心-开始考试"
        }
      },
      {
        path: "/practiceTest",
        name: "practiceTest",
        hidden: true,
        component: resolve => require(["@/views/business/realTest/practiceTest.vue"], resolve),
        meta: {
          title: "练习中心-考试练习题"
        }
      },
      //查看论文
      {
        path: "/graduationDel",
        name: "graduationDel",
        hidden: true,
        component: resolve => require(["@/views/business/personalDetail/graduationDel.vue"], resolve),
        meta: {
          title: "查看论文"
        }
      },
    ]
  },
  // 首页
  {
    path: "/",
    name: "Template",
    alwaysShow: true,
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "首页",
      icon: 'iconfont iconyemian-copy-copy-copy',
    },
    children: [
      {
        path: "/home",
        name: "home",
        components: {
          default: resolve => require(["@/views/business/home/index.vue"], resolve),
          sideBanner: SideBanner
        },
        meta: {
          title: "首页",
          icon: 'iconfont iconyemian-copy-copy-copy',
        }
      },
    ]
  },
  // 学习中心
  {
    path: "/learning",
    name: "learning",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "学习中心",
      icon: 'iconfangkuailiebiao',
    },
    children: [

    ]
  },
  // 学习记录
  {
    path: "/learningRecords",
    name: "learningRecords",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "学习记录",
      icon: 'iconboshimao1',
    },
    children: [
      {
        path: "/classRecord",
        name: "classRecord",
        component: resolve => require(["@/views/business/record/classRecord.vue"], resolve),
        meta: {
          title: "听课记录"
        }
      },
      {
        path: "/problemRecord",
        name: "problemRecord",
        component: resolve => require(["@/views/business/record/classRecord.vue"], resolve),
        meta: {
          title: "做题记录"
        }
      },
      {
        path: "/errorRecord",
        name: "errorRecord",
        component: resolve => require(["@/views/business/record/classRecord.vue"], resolve),
        meta: {
          title: "易错题集"
        }
      },
      {
        path: "/myCollect",
        name: "myCollect",
        component: resolve => require(["@/views/business/record/classRecord.vue"], resolve),
        meta: {
          title: "我的收藏"
        }
      },
      {
        path: "/myNotes",
        name: "myNotes",
        component: resolve => require(["@/views/business/record/classRecord.vue"], resolve),
        meta: {
          title: "我的笔记"
        }
      },
    ]
  },
  // 练习中心
  {
    path: "/practice",
    name: "practice",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "练习中心",
      icon: 'iconbianzu',
    },
    children: [
      // {
      //   path: "/allTest",
      //   name: "allTest",
      //   component: resolve => require(["@/views/business/realTest/index.vue"], resolve),
      //   meta: {
      //     title: "智能练习"
      //   }
      // },
    ]
  },
  // 考试中心
  {
    path: "/examCenterOwn",
    name: "examCenterOwn",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "考试中心",
      icon: 'iconfangkuailiebiao',
    },
    children: [

    ]
  },
  // 毕业设计（论文）及答辩
  {
    path: "/thesisDefense",
    name: "thesisDefense",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "毕设（论文）及答辩",
      icon: 'iconfangkuailiebiao',
    },
    children: [

    ]
  },
  // 个人中心
  {
    path: "/personal",
    name: "personal",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "个人中心",
      icon: 'iconshuben',
    },
    children: [
      // {
      //   path: "/academicDegree",
      //   name: "academicDegree",
      //   component: resolve => require(["@/views/business/personalDetail/academicDegree.vue"], resolve),
      //   meta: {
      //     title: "学位"
      //   }
      // },
    ]
  },
  // 消息中心
  {
    path: "/news",
    name: "news",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "消息中心",
      icon: 'iconbiaoji1',
    },
    children: [
      {
        path: "/studentMessageCenter",
        name: "studentMessageCenter",
        component: resolve => require(["@/views/business/studentMessageCenter/index.vue"], resolve),
        meta: {
          title: "我的消息"
        }
      },
      // {
      //   path: "/options",
      //   name: "options",
      //   component: resolve => require(["@/views/business/userCenter/options.vue"], resolve),
      //   meta: {
      //     title: "投诉建议"
      //   }
      // },
      {
        path: "/studentNotices",
        name: "studentNotices",
        component: resolve => require(["@/views/business/studentMessageCenter/notice.vue"], resolve),
        meta: {
          title: "公告通知"
        }
      },
      {
        path: "/mailbox",
        name: "mailbox",
        component: resolve => require(["@/views/business/userCenter/mailbox.vue"], resolve),
        meta: {
          title: "校长信箱"
        }
      },
    ]
  },
];

// 动态加载的页面 成教/自考
export const asyncRoutes = {
  // 自考
  own: [
    // 公共页面
    {
      path: "",
      name: "Template",
      hidden: true,
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "公共页面",
        icon: 'iconfont iconyemian-copy-copy-copy',
      },
      children: [
        {
          path: "/practice",
          name: "practice",
          hidden: true,
          component: resolve => require(["@/views/business/practice/index.vue"], resolve),
          meta: {
            title: "我的作业"
          }
        },
      ]
    },
    // 学习中心
    {
      path: "/learning",
      name: "learning",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "学习中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/course",
          name: "course",
          component: resolve => require(["@/views/business/course/course.vue"], resolve),
          meta: {
            title: "课程学习"
          }
        },
        {
          path: "/majorPlan",
          name: "majorPlan",
          component: resolve => require(["@/views/business/majorPlan/index.vue"], resolve),
          meta: {
            title: "专业计划"
          }
        },
      ]
    },
    // 练习中心
    {
      path: "/practice",
      name: "practice",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "练习中心",
        icon: 'iconbianzu',
      },
      children: [
        {
          path: "/allTest",
          name: "allTest",
          component: resolve => require(["@/views/business/realTest/index.vue"], resolve),
          meta: {
            title: "智能练习"
          }
        },
      ]
    },
    // 考试中心
    {
      path: "/examCenterOwn",
      name: "examCenterOwn",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "考试中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/participateTestOwn",
          name: "participateTestOwn",
          component: resolve => require(["@/views/business/examCenterOwn/participateTestOwn/participateTestOwn.vue"], resolve),
          meta: {
            title: "我的考试"
          }
        },
        {
          path: "/examSignInOwn",
          name: "examSignInOwn",
          hidden: true,
          component: resolve => require(["@/views/business/examCenterOwn/examSignInOwn/examSignInOwn.vue"], resolve),
          meta: {
            title: "考试签到表"
          }
        },
        {
          path: "/examChurchOwn",
          name: "examChurchOwn",
          hidden: true,
          component: resolve => require(["@/views/business/examCenterOwn/examChurchOwn/examChurchOwn.vue"], resolve),
          meta: {
            title: "查看堂次"
          }
        },
      ]
    },
    // 毕业设计(论文)及答辩
    {
      path: "/thesisDefense",
      name: "thesisDefense",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "毕设（论文）及答辩"
      },
      children: [
        // {
        //   path: "/graduationAE",
        //   name: "graduationAE",
        //   component: resolve => require(["@/views/business/personalDetail/graduation/graduationAE.vue"], resolve),
        //   meta: {
        //     title: "任务开题"
        //   }
        // },
        {
          path: "/viewOpeningReportAE",
          name: "viewOpeningReportAE",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/graduation/viewOpeningReportAE.vue"], resolve),
          meta: {
            title: "设计撰写"
          }
        },
        // // {
        // //   path: "/graduationST",
        // //   name: "graduationST",
        // //   component: resolve => require(["@/views/business/personalDetail/graduation/graduationST.vue"], resolve),
        // //   meta: {
        // //     title: "毕业论文"
        // //   }
        // // },
        {
          path: "/reply",
          name: "reply",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/reply.vue"], resolve),
          meta: {
            title: "答辩申请"
          }
        },
        {
          path: "/defenseSession",
          name: "defenseSession",
          component: resolve => require(["@/views/business/personalDetail/defenseSession.vue"], resolve),
          meta: {
            title: "毕业答辩"
          }
        },
        {
          path: "/gradeApplication",
          name: "gradeApplication",
          component: resolve => require(["@/views/business/personalDetail/gradeApplication.vue"], resolve),
          meta: {
            title: "成绩申请"
          }
        },
        {
          path: "/graduateDefense",
          name: "graduateDefense",
          component: resolve => require(["@/views/business/personalDetail/graduateDefense.vue"], resolve),
          meta: {
            title: "毕业设计及答辩"
          }
        },
      ]
    },
    // 个人中心
  {
    path: "/personal",
    name: "personal",
    component: resolve => require(["@/views/layout/template.vue"], resolve),
    meta: {
      title: "个人中心",
      icon: 'iconshuben',
    },
    children: [
      {
        path: "/informationST",
        name: "informationST",
        components: {
          default: resolve => require(["@/views/business/concatTeacher/information/informationST.vue"], resolve),
          sideBanner: SideBanner
        },
        meta: {
          title: "个人信息"
        }
      },
      {
        path: "/myGradesData",
        name: "myGradesData",
        components: {
          default: resolve => require(["@/views/business/concatTeacher/myGrades.vue"], resolve)
          // sideBanner: SideBanner,
        },
        meta: {
          title: "学习成绩"
        }
      },
      // {
      //   path: "/graduationST",
      //   name: "graduationST",
      //   component: resolve => require(["@/views/business/personalDetail/graduation/graduationST.vue"], resolve),
      //   meta: {
      //     title: "毕业论文"
      //   }
      // },
      // {
      //   path: "/academicDegree",
      //   name: "academicDegree",
      //   component: resolve => require(["@/views/business/personalDetail/academicDegree.vue"], resolve),
      //   meta: {
      //     title: "学位"
      //   }
      // },
    ]
  },
  ],
  // 成教
  adult: [
    // 公共页面
    {
      path: "",
      name: "Template",
      hidden: true,
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "公共页面",
        icon: 'iconfont iconyemian-copy-copy-copy',
      },
      children: [
        {
          path: "/subjectAdult",
          name: "subjectAdult",
          hidden: true,
          component: resolve => require(["@/views/business/course/subjectAdult.vue"], resolve),
          meta: {
            title: "课程计划-学习"
          }
        },
        {
          path: "/practiceAdult",
          name: "practiceAdult",
          hidden: true,
          component: resolve => require(["@/views/business/practice/practiceAdult.vue"], resolve),
          meta: {
            title: "我的作业"
          }
        },
      ]
    },
    // 学习中心
    {
      path: "/learning",
      name: "learning",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "学习中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/courseAdult",
          name: "courseAdult",
          component: resolve => require(["@/views/business/course/courseAdult.vue"], resolve),
          meta: {
            title: "课程学习"
          }
        },
        {
          path: "/myCourse",
          name: "myCourse",
          component: resolve => require(["@/views/business/myCourse/index.vue"], resolve),
          meta: {
            title: "我的课程"
          }
        },
        {
          path: "/curriculum",
          name: "curriculum",
          component: resolve => require(["@/views/business/personalDetail/curriculum.vue"], resolve),
          meta: {
            title: "我的课表"
          }
        },
      ]
    },
    // 练习中心
    {
      path: "/practice",
      name: "practice",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "练习中心",
        icon: 'iconbianzu',
      },
      children: [
        {
          path: "/allTestAE",
          name: "allTestAE",
          component: resolve => require(["@/views/business/realTest/realTestAE.vue"], resolve),
          meta: {
            title: "智能练习"
          }
        },
      ]
    },
    // 考试中心
    {
      path: "/examCenterOwn",
      name: "examCenterOwn",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "考试中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/participateTestAdult",
          name: "participateTestAdult",
          component: resolve => require(["@/views/business/examCenterAdult/participateTestAdult/participateTestAdult.vue"], resolve),
          meta: {
            title: "我的考试"
          }
        },
        {
          path: "/myExamGrades",
          name: "myExamGrades",
          component: resolve => require(["@/views/business/examCenterOwn/myExamGrades/myExamGrades.vue"], resolve),
          meta: {
            title: "我的成绩"
          }
        },
        {
        path: "/achievementRecord",
        name: "achievementRecord",
        component: resolve => require(["@/views/business/examCenterOwn/achievementRecord/achievementRecord.vue"], resolve),
        meta: {
          title: "成绩记录"
        }
        },
        {
          path: "/myGradesData",
          name: "myGradesData",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/myGrades.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "学习成绩"
          }
        },
        {
          path: "/makeUpExamSignUp",
          name: "makeUpExamSignUp",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/makeUpExamSignUp.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "补考报名"
          }
        },
        {
          path: "/exemptionApplication",
          name: "exemptionApplication",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/exemptionApplication.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "免考申请"
          }
        },
      ]
    },
    // 毕业设计(论文)及答辩
    {
      path: "/thesisDefense",
      name: "thesisDefense",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "毕设（论文）及答辩"
      },
      children: [
        // {
        //   path: "/graduationAE",
        //   name: "graduationAE",
        //   component: resolve => require(["@/views/business/personalDetail/graduation/graduationAE.vue"], resolve),
        //   meta: {
        //     title: "任务开题"
        //   }
        // },
        {
          path: "/viewOpeningReportAE",
          name: "viewOpeningReportAE",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/graduation/viewOpeningReportAE.vue"], resolve),
          meta: {
            title: "设计撰写"
          }
        },
        {
          path: "/reply",
          name: "reply",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/reply.vue"], resolve),
          meta: {
            title: "答辩申请"
          }
        },
        {
          path: "/defenseSession",
          name: "defenseSession",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/defenseSession.vue"], resolve),
          meta: {
            title: "毕业答辩"
          }
        },
        {
          path: "/gradeApplication",
          name: "gradeApplication",
          hidden: true,
          component: resolve => require(["@/views/business/personalDetail/gradeApplication.vue"], resolve),
          meta: {
            title: "成绩申请"
          }
        },
        {
          path: "/graduateDefense",
          name: "graduateDefense",
          component: resolve => require(["@/views/business/personalDetail/graduateDefense.vue"], resolve),
          meta: {
            title: "毕业设计及答辩"
          }
        },
      ]
    },
    // 个人中心
    {
      path: "/personal",
      name: "personal",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "个人中心",
        icon: 'iconshuben',
      },
      children: [
        // {
        //   path: "/updatePhone",
        //   name: "updatePhone",
        //   component: resolve => require(["@/views/business/concatTeacher/updatePhone.vue"], resolve),
        //   meta: {
        //     title: "学生端-修改手机号码"
        //     }
        // },
        // {
        //   path: "/courseList",
        //   name: "courseList",
        //   component: resolve => require(["@/views/business/personalDetail/courseList.vue"], resolve),
        //   meta: {
        //     title: "我的课程"
        //   }
        // },
        {
          path: "/informationAE",
          name: "informationAE",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/information/informationAE.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "个人信息"
          }
        },
        {
          path: "/preEducation",
          name: "preEducation",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/preEducation.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "前置学历"
          }
        },
        {
          path: "/gradPhoto",
          name: "gradPhoto",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/gradPhoto.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "毕业照"
          }
        },
        {
          path: "/infoModify",
          name: "infoModify",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/infoModify.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "基础信息修改"
          }
        },
      ]
    },
  ],
  // 成教-专科
  adultJCE: [
    // 公共页面
    {
      path: "",
      name: "Template",
      hidden: true,
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "公共页面",
        icon: 'iconfont iconyemian-copy-copy-copy',
      },
      children: [
        {
          path: "/subjectAdult",
          name: "subjectAdult",
          hidden: true,
          component: resolve => require(["@/views/business/course/subjectAdult.vue"], resolve),
          meta: {
            title: "课程计划-学习"
          }
        },
        {
          path: "/practiceAdult",
          name: "practiceAdult",
          hidden: true,
          component: resolve => require(["@/views/business/practice/practiceAdult.vue"], resolve),
          meta: {
            title: "我的作业"
          }
        },
      ]
    },
    // 学习中心
    {
      path: "/learning",
      name: "learning",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "学习中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/courseAdult",
          name: "courseAdult",
          component: resolve => require(["@/views/business/course/courseAdult.vue"], resolve),
          meta: {
            title: "课程学习"
          }
        },
        {
          path: "/myCourse",
          name: "myCourse",
          component: resolve => require(["@/views/business/myCourse/index.vue"], resolve),
          meta: {
            title: "我的课程"
          }
        },
        {
          path: "/curriculum",
          name: "curriculum",
          component: resolve => require(["@/views/business/personalDetail/curriculum.vue"], resolve),
          meta: {
            title: "我的课表"
          }
        },
      ]
    },
    // 练习中心
    {
      path: "/practice",
      name: "practice",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "练习中心",
        icon: 'iconbianzu',
      },
      children: [
        {
          path: "/allTestAE",
          name: "allTestAE",
          component: resolve => require(["@/views/business/realTest/realTestAE.vue"], resolve),
          meta: {
            title: "智能练习"
          }
        },
      ]
    },
    // 考试中心
    {
      path: "/examCenterOwn",
      name: "examCenterOwn",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "考试中心",
        icon: 'iconfangkuailiebiao',
      },
      children: [
        {
          path: "/participateTestAdult",
          name: "participateTestAdult",
          component: resolve => require(["@/views/business/examCenterAdult/participateTestAdult/participateTestAdult.vue"], resolve),
          meta: {
            title: "我的考试"
          }
        },
        {
          path: "/myExamGrades",
          name: "myExamGrades",
          component: resolve => require(["@/views/business/examCenterOwn/myExamGrades/myExamGrades.vue"], resolve),
          meta: {
            title: "我的成绩"
          }
        },
        {
        path: "/achievementRecord",
        name: "achievementRecord",
        component: resolve => require(["@/views/business/examCenterOwn/achievementRecord/achievementRecord.vue"], resolve),
        meta: {
          title: "成绩记录"
        }
        },
        {
          path: "/myGradesData",
          name: "myGradesData",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/myGrades.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "学习成绩"
          }
        },
        {
          path: "/makeUpExamSignUp",
          name: "makeUpExamSignUp",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/makeUpExamSignUp.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "补考报名"
          }
        },
        {
          path: "/exemptionApplication",
          name: "exemptionApplication",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/exemptionApplication.vue"], resolve)
            // sideBanner: SideBanner,
          },
          meta: {
            title: "免考申请"
          }
        },
      ]
    },
    // 毕业设计(论文)及答辩
    {
      path: "/thesisDefense",
      name: "thesisDefense",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "毕设（论文）及答辩"
      },
      children: [
        {
          path: "/graduationAE",
          name: "graduationAE",
          component: resolve => require(["@/views/business/personalDetail/graduation/graduationAE.vue"], resolve),
          meta: {
            title: "任务开题"
          }
        },
        {
          path: "/viewOpeningReportVocationalAdultJCE",
          name: "viewOpeningReportVocationalAdultJCE",
          component: resolve => require(["@/views/business/personalDetail/graduation/viewOpeningReportVocationalAdultJCE.vue"], resolve),
          meta: {
            title: "设计撰写"
          }
        },
        {
          path: "/gradeApplicationAdultJCE",
          name: "gradeApplicationAdultJCE",
          component: resolve => require(["@/views/business/gradeApplicationAdultJCE/gradeApplicationAdultJCE.vue"], resolve),
          meta: {
            title: "成绩申请"
          }
        },
      ]
    },
    // 个人中心
    {
      path: "/personal",
      name: "personal",
      component: resolve => require(["@/views/layout/template.vue"], resolve),
      meta: {
        title: "个人中心",
        icon: 'iconshuben',
      },
      children: [
        // {
        //   path: "/updatePhone",
        //   name: "updatePhone",
        //   component: resolve => require(["@/views/business/concatTeacher/updatePhone.vue"], resolve),
        //   meta: {
        //     title: "学生端-修改手机号码"
        //     }
        // },
        // {
        //   path: "/courseList",
        //   name: "courseList",
        //   component: resolve => require(["@/views/business/personalDetail/courseList.vue"], resolve),
        //   meta: {
        //     title: "我的课程"
        //   }
        // },
        {
          path: "/informationAE",
          name: "informationAE",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/information/informationAE.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "个人信息"
          }
        },
        {
          path: "/preEducation",
          name: "preEducation",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/preEducation.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "前置学历"
          }
        },
        {
          path: "/gradPhoto",
          name: "gradPhoto",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/gradPhoto.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "毕业照"
          }
        },
        {
          path: "/infoModify",
          name: "infoModify",
          components: {
            default: resolve => require(["@/views/business/concatTeacher/infoModify.vue"], resolve),
            sideBanner: SideBanner
          },
          meta: {
            title: "基础信息修改"
          }
        },
      ]
    },
  ],
};

const createRouter = () => new VueRouter({
  // mode: 'history',
  routes: constantRoutes
});

// 路由守卫
// router.beforeEach((to, from, next) => {
//   if (to.name === "uploadImg" || to.name === "upDataID") {
//     next();
//     return;
//   }
//   const token = getStore("token");
//   const noToken = ["forgetPwd", "verifyCode", "appRule", "appPrivacy", "appDownload", "appHome"];//不需要登录就能进入的路由
//   if (noToken.indexOf(to.name) != -1) {
//     next();
//   } else if (to.name !== "Login" && !token) {
//     Message({
//       message: "登陆已过期，请重新登陆",
//       type: "warning"
//     });
//     next({ name: "Login" });
//   } else {
//     next();
//   }
// });

const router = createRouter();

// 解决重复点击当前路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
